/* eslint-disable react/require-default-props */

import React from 'react';

import ICO_DECREMENT from 'assets/images/ico-decrement.svg';
import ICO_INCREMENT from 'assets/images/ico-increment.svg';

const Counter = (props) => (
  <div className="counter aplication-time cfix" style={props.disabled ? { opacity: 0.5, pointerEvents: 'none' } : undefined}>
    <span className="pull-left label" style={{ color: props.labelColor }}>
      {props.counterLabel}
    </span>
    <div className="counter-btns pull-right f-b">
      <button
        onClick={() => {
          if (props.time > 0) {
            props.changeCounter(props.time - 15);
          }
        }}
        className="decrement"
        disabled={props.disabled}
      >
        <img src={ICO_DECREMENT} alt="Button decrement" />
      </button>
      <strong>{props.timeInHour}</strong>
      <button
        onClick={() => {
          props.changeCounter(props.time + 15);
        }}
        className="increment"
        disabled={props.disabled}
      >
        <img src={ICO_INCREMENT} alt="Button increment" />
      </button>
    </div>
  </div>
);

Counter.defaultProps = { labelColor: '' };

export default Counter;
